import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/formas-de-pago';

/**
 * GET Formas de pagos
 * @returns {Promise<object[]>}
 */
export const getFormasDePagos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
   * GET Forma de pago
   * @param {number} id
   * @returns {Promise<object|null>}
   */
export const getFormaDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
   * POST Forma de pago
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const postFormaDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
   * PATCH Forma de pago
   * @param {number} id
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const patchFormaDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
   * DELETE Formas de pagos
   * @param {number} id
   * @returns {Promise<boolean>}
   */
export const deleteFormaDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
